import React from 'react';
import { Mail, MessageCircle, Share2 } from 'lucide-react';
import { shareOutreach } from '../../utils/outreachShare';

/**
 * Botões compactos: compartilhar nativo / área de transferência, WhatsApp e e-mail.
 * @param {{ subject: string; text: string; className?: string }} props
 */
const OutreachShareMenu = ({ subject, text, className = '' }) => {
  if (!text || !String(text).trim()) return null;

  const stop = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <div
      className={`inline-flex items-center gap-0.5 rounded-lg border border-gray-200 bg-white/95 p-0.5 shadow-sm ${className}`}
      role="group"
      aria-label="Enviar ou compartilhar conteúdo"
    >
      <button
        type="button"
        title="Compartilhar ou copiar"
        className="rounded-md p-2 text-gray-600 transition-colors hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500"
        onClick={(e) => {
          stop(e);
          shareOutreach.native(subject, text);
        }}
      >
        <Share2 className="h-4 w-4" aria-hidden />
      </button>
      <button
        type="button"
        title="Enviar por WhatsApp"
        className="rounded-md p-2 text-gray-600 transition-colors hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500"
        onClick={(e) => {
          stop(e);
          shareOutreach.whatsapp(text);
        }}
      >
        <MessageCircle className="h-4 w-4" aria-hidden />
      </button>
      <button
        type="button"
        title="Enviar por e-mail"
        className="rounded-md p-2 text-gray-600 transition-colors hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500"
        onClick={(e) => {
          stop(e);
          shareOutreach.email(subject, text);
        }}
      >
        <Mail className="h-4 w-4" aria-hidden />
      </button>
    </div>
  );
};

export default OutreachShareMenu;
